import { DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommSendLoadOptions extends Layout {
    labelArrivedRadiusUOM: Label;
    labelArrivingRadiusUOM: Label;
    labelDepartRadiusUOM: Label;
    panelDrvrTechWeb: Panel;
    labelDetentionTimeUOM: Label;
    labelStartOffsetUOM: Label;
    labelEmbeddedWorkflowTemplates: Label;
    panelHeader: Panel;
    panelPegasus: Panel;
    panelBluetree: Panel;
    panelPeopleNet: Panel;
    panelPlatformScience: Panel;
    panelQCWorkflow: Panel;
    panelSymphony: Panel;
    sourceMcMdFormDetail: DataSource;
    sourceMcMdFormHeader: DataSource;
    sourceMcZmitOptions: DataSource;
    switchArrivedVerify: Switch;
    switchBeepArrived: Switch;
    switchBeepDeparted: Switch;
    switchCallOnEnd: Switch;
    switchCallOnStart: Switch;
    switchDepartedVerify: Switch;
    switchDisableAutoEnd: Switch;
    switchDisableDriverEnd: Switch;
    switchTripStartVerify: Switch;
    tabForms: Tab;
    tabGeneral: Tab;
    tabOuterForms: Tab;
    tabRadius: Tab;
    tabTemplates: Tab;
    tabTree: Tab;
    tabTripData: Tab;
    tableEmbeddedWorkflowTemplates: Table;
    tabsetGeneral: Tabset;
    tabsetSendLoadOptions: Tabset;
    textboxArriveConsigneeForm: Textbox;
    textboxArriveShipperForm: Textbox;
    textboxArriveStopForm: Textbox;
    textboxArrivedRadius: Textbox;
    textboxArrivingRadius: Textbox;
    textboxConsigneeForm: Textbox;
    textboxConsigneeTemplate: Textbox;
    textboxDepartConsigneeForm: Textbox;
    textboxDepartRadius: Textbox;
    textboxDepartShipperForm: Textbox;
    textboxDepartStopForm: Textbox;
    textboxDetentionTime: Textbox;
    textboxDetentionType: Textbox;
    textboxDispatchRefType: Textbox;
    textboxDispatchTemplate: Textbox;
    textboxDriverLoginForm: Textbox;
    textboxEmptyConsigneeForm: Textbox;
    textboxEmptyShipperForm: Textbox;
    textboxEmptyStopForm: Textbox;
    textboxLocationId: Textbox;
    textboxMcControlId: Textbox;
    textboxReferenceQual: Textbox;
    textboxShipperForm: Textbox;
    textboxShipperTemplate: Textbox;
    textboxStartOffset: Textbox;
    textboxStopForm: Textbox;
    textboxStopTemplate: Textbox;
}
